import {usePrefetchQuery} from '@tanstack/react-query';
import {OperableAccount} from '~/redux/finances/domain';
import {useSepaRequisitesOptions} from '../../api/withdraw/sepaRequisites';

export type SepaRequisitesPrefetcherProps = {
    account: OperableAccount;
};

export function WithdrawSepaRequisitesPrefetcher({account}: SepaRequisitesPrefetcherProps) {
    usePrefetchQuery(useSepaRequisitesOptions(account.id));
    return null;
}
